export class Controller {

    /** @ngInject */
    constructor($rootScope, Alert, RecoverySettingsService) {
        this.$rootScope = $rootScope;
        this.Alert = Alert;
        this.RecoverySettingsService = RecoverySettingsService;
    }

    $onInit() {
        if (this.$rootScope.account.hasVerifiedNumbers) {
            this.popoverTemplate = require('./go-to-recovery-options.html');
        } else {
            this.popoverTemplate = require('./go-to-add-number.html');
        }
    }

    close() {
        this.popoverIsOpen = false;
        if (this.doNotRemind) {
            this.RecoverySettingsService.changeRecoveryReminder.save(() => {
                this.$rootScope.account.recoveryReminder = false;
            }, () => {
                this.Alert('danger', 'recovery.action_text.change_reminder_failed');
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/recovery-settings/recovery-reminder/recovery-reminder.controller.js